.topFlavorsContainer {
  margin-top: 16px;
}

.flavorsScrollContainer {
  display: flex;
  width: 100%;
  gap: 16px;
  margin-top: 16px;
  overflow-x: scroll;
  scrollbar-width: none;
}

.flavorsScrollContainer::-webkit-scrollbar {
  display: none;
}

@media (--reefer-media-tablet-min) {
  .topFlavorsContainer {
    margin-top: 24px;
  }
}
